import { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'

//	Ref: https://reacttraining.com/react-router/web/guides/scroll-restoration
class ScrollToTop extends Component {
	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			global.scrollTo(0, 0)
		}
	}

	render() {
		return this.props.children
	}
}


ScrollToTop.propTypes = {
	/* eslint-disable react/forbid-prop-types */
	location: PropTypes.object.isRequired,
	children: PropTypes.node.isRequired
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.jsx